import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 15px 0;

  .label {
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    padding: 0 0 15px;
    color: var(--color-text-muted);
  }

  .datepicker-wrapper input {
    height: 40px;
    width: 150px;
    background: var(--color-surface);
  }
`;
